<template>
  <div class="field-dispatch-workteam">
    <Input
      v-model="label"
      :placeholder="`请选择${fieldModel.label}`"
      :disabled="fieldModel.disabled"
      @on-focus="show = true"
    />
    <Drawer
      class-name="dispatch-workteam"
      v-model="show"
      width="90"
      :closable="true"
      title="选择施工队（点击工长姓名选择）"
      transfer
    >
      <workteam-process
        v-bind="workteamProcessBind"
        @on-click-header="onSelectedTeam"
      ></workteam-process>
    </Drawer>
  </div>
</template>

<script>
export default {
  props: ['value', 'fieldModel'],
  data() {
    return {
      show: false,
      showWorkteamProcess: false,
      label: '',
    }
  },
  computed: {
    workteamProcessBind() {
      return {
        companyId: this.fieldModel.params.companyId,
        date: this.fieldModel.params.date,
        beginDate: this.fieldModel.params.date,
        endDate: this.$dayjs(this.fieldModel.params.date)
          .add(60, 'day')
          .format('YYYY-MM-DD'),
      }
    },
  },
  methods: {
    onSelectedTeam(team) {
      this.label = team.label
      this.$emit('input', team.value)
      this.show = false
    },
  },
}
</script>
<style lang="stylus" scoped>
.field-dispatch-workteam
  width 100%
  display flex
  margin-bottom 10px
</style>
<style lang="stylus">
.dispatch-workteam
  .ivu-drawer-body
    display flex
    flex-flow column
</style>
